import { searchFormStorage } from '../../../common-assets/js/components/search/search_form_storage';
import { simpleSearch } from './components/simple_search';
import {
    commonUtils,
    COUNTRY_FINLAND_ID,
    COUNTRY_PREFIX,
    REGION_OUTSIDE_FINLAND_ID,
} from '../../../common-assets/js/components/common_utils';
import { ACC_TOW_BAR_ID, DRIVE_TYPE_FOUR_WHEEL_ID } from './components/car_option_interface';

// Synchronize simple search form with stored state (IndexedDB)
export const syncSimpleSearchForm = {
    get simpleSearchForm() {
        return $('#simple_search');
    },

    loadSimpleSearchForm(action = '', fieldName = '') {
        if (this.simpleSearchForm.length === 0 || $('.leftSearchForm').length === 0) {
            return;
        }

        searchFormStorage.getFormData().then(async (formData) => {
            const isReset = action === 'resetPartially' || action === 'resetAll';
            const isInit = action === 'init';
            await this.updateVehicleTypes(formData, isInit, isReset, fieldName);
            await this.updateBodyTypes(formData, isInit, isReset, fieldName);
            await this.updateFuelTypes(formData, isInit, isReset, fieldName);
            await this.updateMakeModel(formData, isInit, isReset, fieldName);
            await this.updateLocations(formData, isInit, isReset, fieldName);

            // Update scalar/range elements (price/year etc.)
            this.simpleSearchForm
                .find('input:not([type="hidden"]), select')
                .not(
                    '[name="vehicleType"], [name="bodyType"], [name="fuelType"], [name="make"], [name="model"], [name="region"], [name="town"], [name="country"]'
                )
                .each(function () {
                    const inputFieldName = this.name;
                    const inputFieldValue = formData[inputFieldName] || '';

                    if ('driveTypeFourWheel' === inputFieldName || 'driveType' === inputFieldName) {
                        let driveType = formData.driveType || [];
                        this.checked =
                            driveType.includes(DRIVE_TYPE_FOUR_WHEEL_ID) ||
                            driveType.includes(String(DRIVE_TYPE_FOUR_WHEEL_ID));
                    } else if ('accessoriesTowBar' === inputFieldName) {
                        this.checked = (formData.accessories || []).includes(Number.parseInt(ACC_TOW_BAR_ID, 10));
                    } else {
                        this.value = inputFieldValue;
                    }

                    // Update "to" fields range value if "from" field is selected
                    if (['yearFrom'].includes(inputFieldName)) {
                        // Trigger change event for range fields
                        const event = new Event('change');
                        this.dispatchEvent(event);
                    }

                    // Change style of selected elements OR reset style
                    simpleSearch.changeStyleOfSelectedElement(this);
                });
        });
    },
    async updateVehicleTypes(formData, isInit, isReset, fieldName) {
        const vehicleType = formData.vehicleType || '';
        if (fieldName === 'vehicleType' || (isInit && vehicleType) || isReset) {
            // Set selected text for vehicleType OR reset values
            syncSimpleSearchForm.getTextForMultipleSelection('vehicleType', vehicleType);

            // Change style of selected elements OR reset style
            simpleSearch.changeStyleOfSelectedElement(
                syncSimpleSearchForm.simpleSearchForm.find('[name="vehicleType"]')[0]
            );
        }
    },
    async updateBodyTypes(formData, isInit, isReset, fieldName) {
        const subTypes = formData.bodyType || '';
        if (fieldName === 'bodyType' || (isInit && subTypes) || isReset) {
            // Set selected text for bodyType OR reset values
            syncSimpleSearchForm.getTextForMultipleSelection('bodyType', subTypes);

            // Change style of selected elements OR reset style
            simpleSearch.changeStyleOfSelectedElement(
                syncSimpleSearchForm.simpleSearchForm.find('[name="bodyType"]')[0]
            );
        }
    },
    async updateFuelTypes(formData, isInit, isReset, fieldName) {
        const fuelTypes = formData.fuelType || '';
        if (fieldName === 'fuelType' || (isInit && fuelTypes) || isReset) {
            // Set selected text for fuelType OR reset values
            syncSimpleSearchForm.getTextForMultipleSelection('fuelType', fuelTypes);
            // Change style of selected elements OR reset style
            simpleSearch.changeStyleOfSelectedElement(
                syncSimpleSearchForm.simpleSearchForm.find('[name="fuelType"]')[0]
            );
        }
    },
    async updateMakeModel(formData, isInit, isReset, fieldName) {
        const makeModel = formData.makeModels || {}; // key pattern: make,model => label
        if (fieldName === 'makeModels' || isInit || isReset) {
            if (Object.keys(makeModel).length > 1) {
                $('.makeSingle, .modelSingle').addClass('none');
                $('.makeMultiple').removeClass('none');
                $('.makeMultipleText').text(Object.values(makeModel).join(', '));
            } else if (Object.keys(makeModel).length === 1) {
                $('.makeSingle, .modelSingle').removeClass('none');
                $('.makeMultiple').addClass('none');
                $('.makeMultipleText').text('');

                // Get dependent make, model, First is make, rest is model (BMW series case)
                let makeModelSplit = Object.keys(makeModel)[0].split(',');
                const make = makeModelSplit[0];
                const model = makeModelSplit.slice(1).join(',');

                // Get dependent model
                await syncSimpleSearchForm.getDependentModels(make, model);
            } else {
                $('.makeSingle, .modelSingle').removeClass('none');
                $('.makeMultiple').addClass('none');
                $('.makeMultipleText').text('');

                // Set selected text for make,model OR reset values
                syncSimpleSearchForm.simpleSearchForm.find('[name="make"], [name="model"]').val('');

                // Change style of selected elements OR reset style
                simpleSearch.changeStyleOfSelectedElement(
                    syncSimpleSearchForm.simpleSearchForm.find('[name="make"]')[0]
                );
                simpleSearch.changeStyleOfSelectedElement(
                    syncSimpleSearchForm.simpleSearchForm.find('[name="model"]')[0]
                );
                simpleSearch.disableOrHideDependentEmptyElement('model');
            }
        }
    },
    async updateLocations(formData, isInit, isReset, fieldName) {
        const locations = formData.locations || {};
        if (fieldName === 'locations' || isInit || isReset) {
            const $locationMultipleText = $('.locationMultipleText');
            if (Object.keys(locations).length > 1) {
                $('.locationSingle, .townSingle, .countrySingle').addClass('none');
                $('.locationMultiple').removeClass('none');
                $locationMultipleText.html(Object.values(locations).join(', '));
            } else if (Object.keys(locations).length === 1) {
                const selectedLocation = Object.keys(locations)[0];
                $('.locationSingle, .townSingle').removeClass('none');
                $('.locationMultiple').addClass('none');
                $locationMultipleText.html('');

                if (selectedLocation.startsWith(COUNTRY_PREFIX)) {
                    $('.locationSingle').removeClass('none');
                    $('.locationMultiple, .townSingle').addClass('none');
                    $locationMultipleText.html('');
                    const $region = syncSimpleSearchForm.simpleSearchForm.find('[name="region"]');
                    if (selectedLocation === COUNTRY_PREFIX + COUNTRY_FINLAND_ID) {
                        $region.val(0);
                        simpleSearch.changeStyleOfSelectedElement($region[0]);
                    } else {
                        $('.countrySingle').removeClass('none');
                        $region.val(REGION_OUTSIDE_FINLAND_ID);
                        simpleSearch.changeStyleOfSelectedElement($region[0]);
                        const $country = syncSimpleSearchForm.simpleSearchForm.find('[name="country"]');
                        $country.val(selectedLocation.replace(COUNTRY_PREFIX, ''));
                        simpleSearch.changeStyleOfSelectedElement($country[0]);
                    }
                } else {
                    // Get dependent region, town
                    const [region = '', town = ''] = Object.keys(locations)[0].split(',');
                    // Get dependent town
                    syncSimpleSearchForm.getDependentTowns(region, town);
                }
            } else {
                $('.locationSingle').removeClass('none');
                $('.locationMultiple, .townSingle, .countrySingle').addClass('none');
                $locationMultipleText.html('');

                // Set selected text for region,town and country OR reset values
                syncSimpleSearchForm.simpleSearchForm.find('[name="region"], [name="town"], [name="country"]').val('');

                // Change style of selected elements OR reset style
                simpleSearch.changeStyleOfSelectedElement(
                    syncSimpleSearchForm.simpleSearchForm.find('[name="region"]')[0]
                );
                simpleSearch.changeStyleOfSelectedElement(
                    syncSimpleSearchForm.simpleSearchForm.find('[name="town"]')[0]
                );
                simpleSearch.changeStyleOfSelectedElement(
                    syncSimpleSearchForm.simpleSearchForm.find('[name="country"]')[0]
                );
            }
        }
    },
    getTextForMultipleSelection(fieldName, value) {
        // If multiple then show text
        if (value && value.length > 1) {
            $(`.${fieldName}Single`).addClass('none');
            $(`.${fieldName}Multiple`).removeClass('none');

            const optionTexts = [];
            $.each(value, function (index, optionValue) {
                const optionText = $(`#simple_search #${fieldName} option[value="${optionValue}"]`).text();
                optionTexts.push(optionText);
            });
            $(`.${fieldName}MultipleText`).text(optionTexts.join(', '));
        } else {
            $(`.${fieldName}Single`).removeClass('none');
            $(`.${fieldName}Multiple`).addClass('none');
            $(`.${fieldName}MultipleText`).html('');
            syncSimpleSearchForm.simpleSearchForm.find(`[name="${fieldName}"]`).val(value);
        }
    },
    getDependentModels(make, model) {
        const paramsObj = {
            changeType: 'make',
            changeFrom: 'advanceSearch',
            make,
        };
        const params = $.param(paramsObj);
        $.get(Routing.generate('ajax_get_options'), params, (response) => {
            $.each(response, function (key, value) {
                if (commonUtils.isObjectEmpty(value)) {
                    simpleSearch.disableOrHideDependentEmptyElement(key);
                } else if ($(`#simple_search #${key}`).length) {
                    simpleSearch.updateSelectElement(key, value);
                }
            });
        })
            .done(() => {
                // Set selected text for make and model OR reset values
                // Change style of selected elements OR reset style
                const $make = syncSimpleSearchForm.simpleSearchForm.find('[name="make"]');
                const $model = syncSimpleSearchForm.simpleSearchForm.find('[name="model"]');
                $make.val(make);
                $model.val(model);
                simpleSearch.changeStyleOfSelectedElement($make[0]);
                simpleSearch.changeStyleOfSelectedElement($model[0]);
            })
            .fail((error) => {
                console.error('Error loading dependent models', error);
            });
    },
    getDependentTowns(region, town) {
        const paramsObj = {
            changeType: 'region',
            changeFrom: 'advanceSearch',
            region,
        };
        const params = $.param(paramsObj);
        $.get(Routing.generate('ajax_get_options'), params, (response) => {
            $.each(response, function (key, value) {
                if (commonUtils.isObjectEmpty(value)) {
                    simpleSearch.disableOrHideDependentEmptyElement(key);
                } else if ($(`#simple_search #${key}`).length) {
                    simpleSearch.updateSelectElement(key, value);
                }
            });
        }).done(() => {
            // Set selected text for region and town OR reset values
            // Change style of selected elements OR reset style
            const $region = syncSimpleSearchForm.simpleSearchForm.find('[name="region"]');
            const $town = syncSimpleSearchForm.simpleSearchForm.find('[name="town"]');
            $region.val(region);
            $town.val(town);
            simpleSearch.changeStyleOfSelectedElement($region[0]);
            simpleSearch.changeStyleOfSelectedElement($town[0]);
        });
    },
};
